<template>
	<div class="container content-container">
		<div class="row">
			<div class="col-24">
				<slot v-if="!notFound"></slot>
				<not-found-content v-if="notFound"></not-found-content>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		props: ['notFound']
	}
</script>